import {AfterViewInit, Component, ElementRef, Host, Input, OnDestroy, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {delay, takeUntil} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';

import {DropdownSelectComponent} from './dropdown-select.component';

@Component({
  selector: 'gp-dropdown-option',
  template: `
    <a class="dropdown-item direction-ltr" (click)="select()">
      <div #displayValue>
        <ng-content></ng-content>
      </div>
    </a>
  `,
  styleUrls: ['./dropdown-option.component.scss']
})
export class DropdownOptionComponent extends Destroyable implements OnDestroy, AfterViewInit {

  @Input('ngValue')
  private value: any;

  @ViewChild('displayValue', {static: true})
  private displayValue: ElementRef;

  constructor(@Host() private host: DropdownSelectComponent,
              private translate: TranslateService) {
    super();
  }

  public ngAfterViewInit() {
    this.setOptionMap();
    this.translate.onLangChange
      .asObservable()
      .pipe(
        delay(200),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe(() => this.setOptionMap());
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    this.host.optionMap.delete(this.value);
  }

  public select() {
    this.host.setValue(this.value);
  }

  private setOptionMap() {
    this.host.optionMap.set(this.value, (this.displayValue.nativeElement.innerText ?? this.displayValue.nativeElement.textContent).trim());
  }
}
